export default "__VITE_ASSET__Dmc1HrJ1__"